import React from "react";
import { useAuth } from "@/context/AuthContext";
import { motion } from "framer-motion";
import { GoogleLogo, ArrowRight } from "@phosphor-icons/react";

export default function Login() {
  const { loginWithGoogle } = useAuth();
  return (
    <div className="min-h-screen pt-16 hero-gradient noise" data-testid="login-page">
      <div className="max-w-6xl mx-auto px-6 md:px-10 pt-16 pb-32 grid md:grid-cols-2 gap-16 items-center">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
          <p className="section-label">Members Area</p>
          <h1 className="font-display text-5xl md:text-7xl tracking-tighter mt-4 leading-[0.95]">
            Welcome<br />to the <em className="text-gradient-gold not-italic">Vault</em>.
          </h1>
          <p className="text-muted mt-6 text-lg max-w-md">
            Sign in once with Google. Pick your role — farmer, buyer, or explore as guest. No passwords to remember.
          </p>
          <ul className="mt-8 space-y-3 text-sm text-cream/80">
            <li className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-saffron" /> Secure single sign-on</li>
            <li className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-saffron" /> Role-based dashboard</li>
            <li className="flex items-center gap-3"><span className="w-1.5 h-1.5 rounded-full bg-saffron" /> Verified business accounts</li>
          </ul>
        </motion.div>

        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.2 }}
          className="glass rounded-3xl p-10">
          <div className="text-center">
            <div className="inline-flex w-16 h-16 rounded-full bg-saffron/10 items-center justify-center mb-6">
              <GoogleLogo size={28} weight="bold" className="text-saffron" />
            </div>
            <h2 className="font-display text-3xl text-cream">Continue with Google</h2>
            <p className="text-sm text-muted mt-2">We'll set you up in 30 seconds.</p>
            <button
              onClick={loginWithGoogle}
              className="btn-primary w-full justify-center mt-8 text-base"
              data-testid="google-signin-btn"
            >
              <GoogleLogo size={20} weight="bold" /> Sign in with Google
              <ArrowRight size={16} weight="bold" />
            </button>
            <p className="text-[10px] uppercase tracking-[0.2em] text-muted/80 mt-6">
              By continuing you agree to WorldFoods2U's terms of service.
            </p>
          </div>
        </motion.div>
      </div>
    </div>
  );
}
